import React from "react";
import ProgressBar from "components/ProgressBar";
import { ALL_TEMPLATE_PAGE_BUILDER_SECTIONS } from "utils/constants/template";
import { useFormikContext } from "formik";
import round from "lodash/round";

const TemplateBuilderProgress = () => {
  const { values } = useFormikContext();
  const sectionKeys = Object.keys(ALL_TEMPLATE_PAGE_BUILDER_SECTIONS);
  const activeIndex = sectionKeys.indexOf(values.form.activeSection);

  const progress = (activeIndex + 1) / sectionKeys.length;
  const progressPct = round(progress, 2) * 100;

  return (
    <ProgressBar
      progress={progressPct}
      customClasses={{
        container: "w-100 relative z-3 bg-white",
        bar: "progressBar absolute h-100 br1 br--right"
      }}
    />
  );
};

export default TemplateBuilderProgress;
